function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.4771 2.93965C12.4771 3.06734 12.3732 3.1708 12.245 3.1708C12.1168 3.1708 12.0129 3.06734 12.0129 2.93965C12.0129 2.81195 12.1168 2.7085 12.245 2.7085C12.3732 2.7085 12.4771 2.81195 12.4771 2.93965Z",
  fill: "white"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.2991 2.93965C13.2991 3.06734 13.1952 3.1708 13.067 3.1708C12.9389 3.1708 12.835 3.06734 12.835 2.93965C12.835 2.81195 12.9389 2.7085 13.067 2.7085C13.1952 2.7085 13.2991 2.81195 13.2991 2.93965Z",
  fill: "white"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.1212 2.93965C14.1212 3.06734 14.0173 3.1708 13.8891 3.1708C13.7609 3.1708 13.657 3.06734 13.657 2.93965C13.657 2.81195 13.7609 2.7085 13.8891 2.7085C14.0173 2.7085 14.1212 2.81195 14.1212 2.93965Z",
  fill: "white"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.4617 27.3131C11.3709 22.3426 9.26321 17.5958 6.30533 13.4475",
  stroke: "#EBEEF4",
  strokeWidth: 0.87197
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.54588 16.4327C8.28183 16.0032 7.95519 15.5768 7.66731 15.1876C7.13265 14.4648 6.83769 13.6995 6.03099 13.2008C5.30376 12.7514 4.42714 12.6273 3.57908 12.5131C3.3445 12.4815 3.04799 12.4798 2.9395 12.6893C2.86704 12.8291 2.9234 13.0072 3.03046 13.123C3.13745 13.2389 3.28535 13.3069 3.42774 13.375C4.3043 13.7943 5.12255 14.3233 5.93808 14.8506C6.41373 15.1583 6.89534 15.4709 7.27438 15.8912C7.9511 16.6414 8.52536 17.4479 9.21117 18.1872C9.15553 18.1271 9.10729 17.4961 9.05321 17.363C8.92031 17.0356 8.73046 16.7329 8.54588 16.4327Z",
  fill: "#EBEEF4"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.2233 22.6927C10.9647 22.496 10.0546 22.6376 9.74135 22.6583C8.95653 22.7099 8.21846 22.759 7.45598 22.9732C6.90378 23.1283 6.33328 23.2838 5.76395 23.2129C5.04419 23.1232 3.89871 22.2152 4.84649 21.5722C5.84809 20.8927 7.58758 21.0195 8.66164 21.3979C9.57716 21.7204 10.4574 22.11 11.2233 22.6927Z",
  fill: "#EBEEF4"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.5173 21.0881C8.51833 18.718 5.64837 18.5764 3.36331 18.5706",
  stroke: "#EBEEF4",
  strokeWidth: 0.87197
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.8226 19.7356C3.8585 19.722 3.89395 19.7076 3.92901 19.6925C4.2937 19.5347 4.65845 19.3764 5.03047 19.2363C5.21947 19.1652 5.41022 19.0984 5.60331 19.0392C5.76737 18.9887 5.92079 18.908 6.0944 18.894C5.34224 18.7365 4.58476 18.6042 3.8237 18.4975C4.65202 18.5686 5.47748 18.6728 6.29743 18.8099C6.05448 18.5701 5.63804 18.4053 5.32737 18.2705C4.99502 18.1263 4.65215 18.0088 4.31123 17.8869C3.56595 17.6203 2.77898 17.4664 1.98475 17.5042C1.53676 17.5255 1.08391 17.5961 0.678448 17.7872C0.448027 17.8958 0.226956 18.0523 0.115284 18.2805C-0.0670267 18.6532 0.102429 19.1246 0.414656 19.3988C0.726883 19.673 1.14825 19.787 1.55936 19.8522C2.28841 19.9678 3.12822 19.9984 3.8226 19.7356Z",
  fill: "#D4E3FB"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M43.528 7.65657C43.5766 7.31389 43.6654 6.95601 43.7401 6.6322C43.8787 6.03083 43.8545 5.46792 44.2263 4.93378C44.5614 4.45234 45.0801 4.13539 45.5834 3.83241C45.7227 3.74861 45.9092 3.66669 46.0351 3.7693C46.1192 3.83771 46.1326 3.96541 46.0969 4.06757C46.0612 4.16972 45.9867 4.25287 45.9155 4.33467C45.478 4.8377 45.1073 5.39414 44.738 5.94878C44.5225 6.27232 44.3046 6.60065 44.1811 6.96881C43.9603 7.62618 43.8198 8.29112 43.5903 8.94403C43.609 8.89108 43.4661 8.48005 43.4636 8.38132C43.4575 8.13872 43.4941 7.89613 43.528 7.65657Z",
  fill: "white"
});

var _ref11 =
/*#__PURE__*/
React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 5,
  y: 38,
  width: 67,
  height: 5
}, React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.7616 38.6875H71.3354V42.7571H5.7616V38.6875Z",
  fill: "white"
}));

var _ref12 =
/*#__PURE__*/
React.createElement("g", {
  mask: "url(#mask0)"
}, React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M44.3703 38.6875C38.3132 38.8176 32.3324 39.097 26.397 39.408C21.188 39.6809 15.424 40.2905 10.2283 39.8142C8.83643 39.6866 6.93217 39.7671 6.13294 40.0992C5.70086 40.2787 5.68618 40.5018 5.88369 40.7037C6.49119 41.3248 8.84474 41.7533 11.2093 42.0429C17.308 42.7898 24.589 42.9603 31.1724 42.5101C32.8139 42.3979 34.409 42.249 36.0504 42.1367C42.0366 41.7269 48.4645 41.8176 54.5164 42.167C56.9402 42.307 59.3329 42.4879 61.8068 42.5611C64.2806 42.6344 66.8955 42.592 69.0884 42.3071C69.6631 42.2325 70.2116 42.1399 70.604 42.0143C71.1377 41.8436 71.3422 41.6235 71.3352 41.4098C71.3173 40.8649 69.9966 40.3575 68.2394 40.0133C66.4822 39.6691 64.3232 39.4666 62.1606 39.3034C56.9806 38.9124 51.5466 38.7168 46.1177 38.7256",
  fill: "#EBEEF4"
}));

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M68.3803 36.6807C68.6716 32.1339 70.2413 27.6751 72.8645 23.9424",
  stroke: "#EBEEF4",
  strokeWidth: 0.87197,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M73.7403 21.4472C73.894 21.2882 74.0946 21.1246 74.3116 21.1697C74.4247 21.1932 74.5189 21.2716 74.5943 21.359C75.5393 22.455 73.7589 25.0443 72.4464 24.9944C70.888 24.9353 73.1801 22.0272 73.7403 21.4472Z",
  fill: "#EBEEF4"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M73.4364 26.8814C73.4388 26.8815 73.4412 26.8817 73.4436 26.8819C74.1898 26.9367 74.1295 27.6292 73.6196 28.0033C72.8486 28.569 71.8983 28.8244 70.9724 29.0683C69.6104 29.4273 70.4774 28.0758 71.0778 27.6693C71.6289 27.2963 72.7522 26.835 73.4364 26.8814Z",
  fill: "#D4E3FB"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M69.777 26.91C69.3765 25.9098 68.2129 26.2821 68.4855 27.2993C68.6767 28.0123 69.1064 28.692 69.5725 29.253C69.6296 29.3219 69.6984 29.3966 69.7881 29.3981C69.9214 29.4006 69.9959 29.247 70.0243 29.1173C70.1789 28.4109 70.0419 27.5712 69.777 26.91Z",
  fill: "#EBEEF4"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M71.899 30.7916C72.3159 30.819 72.598 30.9843 72.5602 31.3264C72.5306 31.5931 72.3129 31.8092 72.0656 31.9154C71.3775 32.2106 70.4712 32.2612 69.736 32.366C69.4071 32.4129 68.9063 32.5424 69.1686 32.0353C69.3663 31.6529 69.8434 31.3636 70.2188 31.1791C70.726 30.9301 71.3285 30.7542 71.899 30.7916Z",
  fill: "#EBEEF4"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M67.2275 31.1664C67.0831 31.0176 66.891 30.9214 66.7447 30.9759C66.5576 31.0456 66.511 31.3246 66.5293 31.5826C66.5726 32.1915 66.8713 32.8308 67.2747 33.3238C67.764 33.9217 68.8791 35.0177 68.6358 33.6302C68.476 32.7186 67.8485 31.8067 67.2275 31.1664Z",
  fill: "#D4E3FB"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M33.1237 34.2803H12.3245C12.0512 34.2803 11.8296 34.0596 11.8296 33.7874V2.82387C11.8296 2.55167 12.0512 2.33105 12.3245 2.33105H33.1237C33.397 2.33105 33.6186 2.55167 33.6186 2.82387V33.7874C33.6186 34.0596 33.397 34.2803 33.1237 34.2803Z",
  fill: "#D4E3FB"
});

var _ref20 =
/*#__PURE__*/
React.createElement("mask", {
  id: "mask1",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 11,
  y: 2,
  width: 23,
  height: 2
}, React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.8297 2.33105H33.6187V3.54815H11.8297V2.33105Z",
  fill: "white"
}));

var _ref21 =
/*#__PURE__*/
React.createElement("g", {
  mask: "url(#mask1)"
}, React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M33.6187 3.54816H11.8297V2.82387C11.8297 2.55173 12.0513 2.33105 12.3246 2.33105H33.1238C33.3971 2.33105 33.6187 2.55173 33.6187 2.82387V3.54816Z",
  fill: "white"
}));

var _ref22 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.855469,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.9522 12.4003H13.6791C13.4871 12.4003 13.3314 12.2453 13.3314 12.054V6.16644C13.3314 5.97512 13.4871 5.82007 13.6791 5.82007H21.9522C22.1443 5.82007 22.2999 5.97512 22.2999 6.16644V12.054C22.2999 12.2453 22.1443 12.4003 21.9522 12.4003Z",
  fill: "white"
});

var _ref23 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.855469,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M31.7687 12.4003H23.4957C23.3035 12.4003 23.1479 12.2453 23.1479 12.054V6.16644C23.1479 5.97512 23.3035 5.82007 23.4957 5.82007H31.7687C31.9608 5.82007 32.1164 5.97512 32.1164 6.16644V12.054C32.1164 12.2453 31.9608 12.4003 31.7687 12.4003Z",
  fill: "white"
});

var _ref24 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.855469,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.9522 20.2541H13.6791C13.4871 20.2541 13.3314 20.099 13.3314 19.9078V14.0202C13.3314 13.8289 13.4871 13.6738 13.6791 13.6738H21.9522C22.1443 13.6738 22.2999 13.8289 22.2999 14.0202V19.9078C22.2999 20.099 22.1443 20.2541 21.9522 20.2541Z",
  fill: "white"
});

var _ref25 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.855469,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M31.7687 20.2541H23.4957C23.3035 20.2541 23.1479 20.099 23.1479 19.9078V14.0202C23.1479 13.8289 23.3035 13.6738 23.4957 13.6738H31.7687C31.9608 13.6738 32.1164 13.8289 32.1164 14.0202V19.9078C32.1164 20.099 31.9608 20.2541 31.7687 20.2541Z",
  fill: "white"
});

var _ref26 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.855469,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.9522 28.1083H13.6791C13.4871 28.1083 13.3314 27.9533 13.3314 27.762V21.8744C13.3314 21.6831 13.4871 21.5281 13.6791 21.5281H21.9522C22.1443 21.5281 22.2999 21.6831 22.2999 21.8744V27.762C22.2999 27.9533 22.1443 28.1083 21.9522 28.1083Z",
  fill: "white"
});

var _ref27 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.855469,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M31.7687 28.1083H23.4957C23.3035 28.1083 23.1479 27.9533 23.1479 27.762V21.8744C23.1479 21.6831 23.3035 21.5281 23.4957 21.5281H31.7687C31.9608 21.5281 32.1164 21.6831 32.1164 21.8744V27.762C32.1164 27.9533 31.9608 28.1083 31.7687 28.1083Z",
  fill: "white"
});

var _ref28 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M31.6658 37.3614C31.3925 37.3614 31.171 37.1408 31.171 36.8686V10.1069C31.171 9.83469 31.3925 9.61401 31.6658 9.61401H67.8873C68.1606 9.61401 68.3822 9.83469 68.3822 10.1069V36.8686C68.3822 37.1408 68.1606 37.3614 67.8873 37.3614H31.6658Z",
  fill: "#EEF1F6"
});

var _ref29 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M68.3823 11.5982H31.1711V10.0713C31.1711 9.8189 31.3765 9.61426 31.63 9.61426H67.9234C68.1768 9.61426 68.3823 9.8189 68.3823 10.0713V11.5982Z",
  fill: "#D4E3FB"
});

var _ref30 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M32.7597 10.6331C32.7597 10.8006 32.6234 10.9363 32.4552 10.9363C32.2871 10.9363 32.1507 10.8006 32.1507 10.6331C32.1507 10.4656 32.2871 10.3298 32.4552 10.3298C32.6234 10.3298 32.7597 10.4656 32.7597 10.6331Z",
  fill: "white"
});

var _ref31 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M33.8383 10.6331C33.8383 10.8006 33.7019 10.9363 33.5338 10.9363C33.3656 10.9363 33.2292 10.8006 33.2292 10.6331C33.2292 10.4656 33.3656 10.3298 33.5338 10.3298C33.7019 10.3298 33.8383 10.4656 33.8383 10.6331Z",
  fill: "white"
});

var _ref32 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M34.9169 10.6331C34.9169 10.8006 34.7804 10.9363 34.6124 10.9363C34.4441 10.9363 34.3078 10.8006 34.3078 10.6331C34.3078 10.4656 34.4441 10.3298 34.6124 10.3298C34.7804 10.3298 34.9169 10.4656 34.9169 10.6331Z",
  fill: "white"
});

var _ref33 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M53.7024 20.5815H33.1071C32.9151 20.5815 32.7594 20.4264 32.7594 20.2351V14.3475C32.7594 14.1563 32.9151 14.0012 33.1071 14.0012H53.7024C53.8944 14.0012 54.0501 14.1563 54.0501 14.3475V20.2351C54.0501 20.4264 53.8944 20.5815 53.7024 20.5815Z",
  fill: "#D4E3FB"
});

var _ref34 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M65.987 27.8137H55.7019C55.5099 27.8137 55.3541 27.6587 55.3541 27.4674V14.3475C55.3541 14.1562 55.5099 14.0012 55.7019 14.0012H65.987C66.179 14.0012 66.3347 14.1562 66.3347 14.3475V27.4674C66.3347 27.6587 66.179 27.8137 65.987 27.8137Z",
  fill: "#D4E3FB"
});

var _ref35 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M65.987 35.0458H55.7019C55.5099 35.0458 55.3541 34.8908 55.3541 34.6995V28.8119C55.3541 28.6206 55.5099 28.4656 55.7019 28.4656H65.987C66.179 28.4656 66.3347 28.6206 66.3347 28.8119V34.6995C66.3347 34.8908 66.179 35.0458 65.987 35.0458Z",
  fill: "#D4E3FB"
});

var _ref36 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M57.9034 31.4889H56.6197C56.4825 31.4889 56.3713 31.3782 56.3713 31.2416V29.9631C56.3713 29.8266 56.4825 29.7158 56.6197 29.7158H57.9034C58.0405 29.7158 58.1517 29.8266 58.1517 29.9631V31.2416C58.1517 31.3782 58.0405 31.4889 57.9034 31.4889Z",
  fill: "white"
});

var _ref37 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M60.2921 31.4889H59.0083C58.8711 31.4889 58.76 31.3782 58.76 31.2416V29.9631C58.76 29.8266 58.8711 29.7158 59.0083 29.7158H60.2921C60.4292 29.7158 60.5404 29.8266 60.5404 29.9631V31.2416C60.5404 31.3782 60.4292 31.4889 60.2921 31.4889Z",
  fill: "white"
});

var _ref38 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M62.6808 31.4889H61.397C61.2598 31.4889 61.1486 31.3782 61.1486 31.2416V29.9631C61.1486 29.8266 61.2598 29.7158 61.397 29.7158H62.6808C62.8179 29.7158 62.9291 29.8266 62.9291 29.9631V31.2416C62.9291 31.3782 62.8179 31.4889 62.6808 31.4889Z",
  fill: "white"
});

var _ref39 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M65.0694 31.4889H63.7856C63.6484 31.4889 63.5373 31.3782 63.5373 31.2416V29.9631C63.5373 29.8266 63.6484 29.7158 63.7856 29.7158H65.0694C65.2065 29.7158 65.3176 29.8266 65.3176 29.9631V31.2416C65.3176 31.3782 65.2065 31.4889 65.0694 31.4889Z",
  fill: "white"
});

var _ref40 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M57.9034 33.796H56.6197C56.4825 33.796 56.3713 33.6853 56.3713 33.5487V32.2702C56.3713 32.1336 56.4825 32.0229 56.6197 32.0229H57.9034C58.0405 32.0229 58.1517 32.1336 58.1517 32.2702V33.5487C58.1517 33.6853 58.0405 33.796 57.9034 33.796Z",
  fill: "white"
});

var _ref41 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M60.2921 33.796H59.0083C58.8711 33.796 58.76 33.6853 58.76 33.5487V32.2702C58.76 32.1336 58.8711 32.0229 59.0083 32.0229H60.2921C60.4292 32.0229 60.5404 32.1336 60.5404 32.2702V33.5487C60.5404 33.6853 60.4292 33.796 60.2921 33.796Z",
  fill: "white"
});

var _ref42 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M62.6808 33.796H61.397C61.2598 33.796 61.1486 33.6853 61.1486 33.5487V32.2702C61.1486 32.1336 61.2598 32.0229 61.397 32.0229H62.6808C62.8179 32.0229 62.9291 32.1336 62.9291 32.2702V33.5487C62.9291 33.6853 62.8179 33.796 62.6808 33.796Z",
  fill: "white"
});

var _ref43 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M65.0694 33.796H63.7856C63.6484 33.796 63.5373 33.6853 63.5373 33.5487V32.2702C63.5373 32.1336 63.6484 32.0229 63.7856 32.0229H65.0694C65.2065 32.0229 65.3176 32.1336 65.3176 32.2702V33.5487C65.3176 33.6853 65.2065 33.796 65.0694 33.796Z",
  fill: "white"
});

var _ref44 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M53.7024 27.8137H33.1071C32.9151 27.8137 32.7594 27.6586 32.7594 27.4674V21.5798C32.7594 21.3885 32.9151 21.2334 33.1071 21.2334H53.7024C53.8944 21.2334 54.0501 21.3885 54.0501 21.5798V27.4674C54.0501 27.6586 53.8944 27.8137 53.7024 27.8137Z",
  fill: "#D4E3FB"
});

var _ref45 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M53.7024 35.0458H33.1071C32.9151 35.0458 32.7594 34.8908 32.7594 34.6995V28.8119C32.7594 28.6206 32.9151 28.4656 33.1071 28.4656H53.7024C53.8944 28.4656 54.0501 28.6206 54.0501 28.8119V34.6995C54.0501 34.8908 53.8944 35.0458 53.7024 35.0458Z",
  fill: "#D4E3FB"
});

var _ref46 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M37.4178 17.2911C37.4178 18.2377 36.6474 19.0049 35.697 19.0049C34.7465 19.0049 33.9761 18.2377 33.9761 17.2911C33.9761 16.3446 34.7465 15.5774 35.697 15.5774C36.6474 15.5774 37.4178 16.3446 37.4178 17.2911Z",
  fill: "white"
});

var _ref47 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M63.2379 18.3845C63.2379 19.7009 62.1663 20.768 60.8445 20.768C59.5226 20.768 58.451 19.7009 58.451 18.3845C58.451 17.0681 59.5226 16.001 60.8445 16.001C62.1663 16.001 63.2379 17.0681 63.2379 18.3845Z",
  fill: "white"
});

var _ref48 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M38.5483 16.4526H51.759V15.9429H38.5483V16.4526Z",
  fill: "white"
});

var _ref49 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M57.0023 22.521H64.687V22.0112H57.0023V22.521Z",
  fill: "#D4E3FB"
});

var _ref50 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M57.0023 23.6851H64.687V23.1753H57.0023V23.6851Z",
  fill: "white"
});

var _ref51 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M59.0107 24.8718H62.6791V24.3621H59.0107V24.8718Z",
  fill: "white"
});

var _ref52 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M38.5483 17.5461H51.759V17.0364H38.5483V17.5461Z",
  fill: "white"
});

var _ref53 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M38.5484 18.6394H47.2391V18.1296H38.5484V18.6394Z",
  fill: "white"
});

var _ref54 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M37.4178 24.5236C37.4178 25.4701 36.6474 26.2374 35.697 26.2374C34.7465 26.2374 33.9761 25.4701 33.9761 24.5236C33.9761 23.5771 34.7465 22.8098 35.697 22.8098C36.6474 22.8098 37.4178 23.5771 37.4178 24.5236Z",
  fill: "white"
});

var _ref55 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M38.5483 23.6851H51.759V23.1753H38.5483V23.6851Z",
  fill: "white"
});

var _ref56 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M38.5483 24.7783H51.759V24.2686H38.5483V24.7783Z",
  fill: "white"
});

var _ref57 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M38.5484 25.8717H47.2391V25.3621H38.5484V25.8717Z",
  fill: "white"
});

var _ref58 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M37.4178 31.7557C37.4178 32.7023 36.6474 33.4696 35.697 33.4696C34.7465 33.4696 33.9761 32.7023 33.9761 31.7557C33.9761 30.8093 34.7465 30.042 35.697 30.042C36.6474 30.042 37.4178 30.8093 37.4178 31.7557Z",
  fill: "white"
});

var _ref59 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M38.5483 30.9171H51.759V30.4075H38.5483V30.9171Z",
  fill: "white"
});

var _ref60 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M38.5483 32.0108H51.759V31.501H38.5483V32.0108Z",
  fill: "white"
});

var _ref61 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M38.5484 33.104H47.2391V32.5942H38.5484V33.104Z",
  fill: "white"
});

var _ref62 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.5978 30.9173C18.5978 31.4806 19.0545 31.9373 19.6178 31.9373H25.8304C26.3938 31.9373 26.8505 31.4806 26.8505 30.9173C26.8505 30.3539 26.3938 29.8972 25.8304 29.8972H19.6178C19.0545 29.8972 18.5978 30.3539 18.5978 30.9173Z",
  fill: "white"
});

var _ref63 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M48.5105 8.57692C49.2202 8.42815 50.2145 8.51045 50.86 8.1851C51.1363 8.04583 51.3503 7.73211 51.2697 7.43436C51.2216 7.25688 51.0777 7.11625 50.9118 7.03549C50.0321 6.607 48.6774 6.55043 47.7151 6.58806C46.6271 6.63054 45.5647 6.9473 44.6979 7.61838C44.2725 7.94774 43.9021 8.36168 43.6899 8.85495C44.3026 8.55972 44.8837 8.25448 45.476 7.92395C45.6872 7.80614 45.9007 7.68737 46.1332 7.62045C46.653 7.4707 47.2081 7.59387 47.7349 7.71737C47.3583 7.79554 46.968 7.77407 46.587 7.82709C45.674 7.95408 44.9379 8.59477 44.1694 9.05274C44.3726 8.9317 45.0409 9.03715 45.2958 9.01362C45.6989 8.97644 46.0998 8.9145 46.4953 8.82812C47.1698 8.68089 47.8288 8.71982 48.5105 8.57692Z",
  fill: "white"
});

var _ref64 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M43.0132 8.65588C42.7144 8.24317 42.2786 7.88451 41.8325 7.63978C41.4999 7.45732 41.1504 7.30589 40.7915 7.18272C40.0923 6.94278 39.2941 6.89764 38.6309 7.22378C38.3947 7.3399 38.1604 7.53646 38.148 7.79852C38.1384 8.00439 38.2729 8.19345 38.4382 8.31746C38.7292 8.53587 39.1107 8.59684 39.475 8.59465C39.8394 8.59245 40.2024 8.53419 40.5666 8.54428C40.9797 8.55572 41.3846 8.65465 41.7857 8.75312C42.0559 8.8194 42.326 8.88586 42.5961 8.95194C42.7107 8.97994 42.8287 9.03749 42.9354 9.06367C42.9777 9.07402 43.1975 9.04848 43.1988 9.04932C42.5217 8.62717 41.7405 8.40449 40.9644 8.21582C40.9156 8.20399 40.8557 8.17864 40.8568 8.12859C41.1495 8.12252 41.443 8.16707 41.7205 8.25966C42.1619 8.40688 42.5881 8.47975 43.0132 8.65588Z",
  fill: "white"
});

var _ref65 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.00215 34.6683C5.68276 35.6304 6.49348 36.5025 7.35544 37.3055C8.05774 37.9598 9.19023 38.6693 9.53226 39.6224C9.04856 38.2745 8.04774 37.507 7.2724 36.3799C6.37259 35.0718 5.42254 33.799 4.41872 32.5683C4.15883 32.2497 3.87283 31.9183 3.47919 31.7966C3.86114 32.8133 4.37432 33.781 5.00215 34.6683Z",
  fill: "#D4E3FB"
});

var _ref66 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.09357 30.0691C8.1981 30.1967 8.20712 30.3991 8.24257 30.5547C8.29217 30.7725 8.34145 30.9903 8.39034 31.2082C8.48818 31.6441 8.58427 32.0803 8.67673 32.5173C8.85657 33.367 9.02304 34.2196 9.16302 35.0767C9.30404 35.9404 9.4187 36.8085 9.49174 37.6807C9.54855 38.3592 9.45687 39.1727 9.63431 39.8256C9.17575 38.1382 8.58707 36.4954 8.21374 34.7812C8.04195 33.9922 7.91846 33.1906 7.88269 32.3834C7.8647 31.976 7.86905 31.5675 7.90178 31.161C7.91814 30.9582 7.94138 30.7559 7.97242 30.5548C7.99494 30.4083 7.96982 30.1713 8.09357 30.0691Z",
  fill: "#D4E3FB"
});

var _ref67 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.28402 38.4527C4.70209 38.7236 4.20554 39.1435 3.71658 39.5584C4.0514 39.6876 4.43297 39.6259 4.76617 39.4929C5.0995 39.3599 5.40127 39.1602 5.72343 39.0025C6.38275 38.6797 7.14056 38.5372 7.86416 38.6637C8.44926 38.7659 8.90952 39.0641 9.36874 39.4065C8.63631 38.062 6.55448 37.8614 5.28402 38.4527Z",
  fill: "#D4E3FB"
});

var _ref68 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.51168 39.4168C9.39891 39.2349 9.28055 39.0489 9.2477 38.8535C9.19335 38.5311 9.20595 38.1937 9.27743 37.875C9.38144 37.411 9.61173 36.982 9.89663 36.6004C10.4803 35.8188 11.3056 35.2186 12.231 34.9028C11.8175 35.5314 11.2979 36.0905 10.7005 36.5495C10.45 36.742 10.2425 36.9873 10.0763 37.2544C9.92623 37.4955 9.86118 37.757 9.73756 38.0084C9.49493 38.5022 9.40793 39.1609 9.65686 39.6697C9.61583 39.5859 9.5644 39.5017 9.51168 39.4168Z",
  fill: "#D4E3FB"
});

var _ref69 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.3593 38.8899C10.4222 38.8878 10.485 38.8859 10.5478 38.8839C10.5558 38.8837 10.5643 38.8835 10.5712 38.8875C10.5852 38.8955 10.586 38.9152 10.585 38.9313C10.5599 39.3039 10.4717 39.6645 10.4306 40.0335C10.4056 40.2578 10.3875 40.4828 10.3624 40.7071C10.3498 40.8194 10.3358 40.9315 10.3185 41.0432C10.2947 41.1961 10.2899 41.2023 10.1343 41.2146C9.65186 41.2532 9.16745 41.2348 8.68402 41.2399C8.66149 41.2401 8.6372 41.2397 8.61896 41.2265C8.60072 41.2131 8.59312 41.1899 8.58663 41.1682C8.55066 41.048 8.02333 39.1816 7.98535 39.2001C8.75836 38.9695 9.56083 38.9172 10.3593 38.8899Z",
  fill: "#D4E3FB"
});

var _ref70 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.13843 6.60524H9.74235V5.9873H4.13843V6.60524Z",
  fill: "white"
});

var _ref71 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.13843 7.85255H9.74235V7.23462H4.13843V7.85255Z",
  fill: "white"
});

var _ref72 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M64.7959 6.60524H70.3997V5.9873H64.7959V6.60524Z",
  fill: "white"
});

var _ref73 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M64.7959 7.85255H70.3997V7.23462H64.7959V7.85255Z",
  fill: "white"
});

var _ref74 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M64.7959 4.07325H70.3997V3.45532H64.7959V4.07325Z",
  fill: "white"
});

var _ref75 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M64.7959 5.32057H70.3997V4.70264H64.7959V5.32057Z",
  fill: "white"
});

var _ref76 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.13843 9.1001H7.91047V8.48218H4.13843V9.1001Z",
  fill: "white"
});

var _ref77 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M58.2232 7.8528H63.2382V3.45532H58.2232V7.8528Z",
  fill: "white"
});

var SvgBgThumb2 = function SvgBgThumb2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 60,
    height: 46,
    viewBox: "0 0 75 46",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBgThumb2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bg-thumb-2.5057717e.svg";
export { ForwardRef as ReactComponent };